import { status } from 'skin/event/status'

const next = (obj, ms, story, data, d, action) => {
    console.log('[Отчет - Мастер] событие', obj);
    const o = {
		name: 'Файл для весов',
		pug: true,
	};
    const act = {
        type: 'data',
        action: 'wAdd',
        code: 'msCSV',
        data: o
    }
    action(act)
    return status.action
}

export default next